module.exports = __webpack_public_path__ + "img/closebtn-icon.8a89b237.svg";